import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import Input from "../components/Input";
import Button from "../components/Button";
import RolePermissionChecklist from "../components/RolePermissionChecklist";
import { addRole } from "../actions/roleActions";
import { ADD_ROLE_RESET } from "../constants/roleConstants";
import { emptyPermissions, hasPermission } from "../constants/rolePermissions";
import ScreenHeader from '../components/layout/ScreenHeader'

const AddRole = () => {
  // * States
  const [name, setName] = useState("");
  const [permissions, setPermissions] = useState(emptyPermissions);

  // * Initialization
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { userInfo: adminInfo } = useSelector((state) => state.adminLogin);
  const { userInfo } = useSelector((state) => state.userLogin);
  const currentRole = adminInfo?.role || userInfo?.role;
  const canAddRoles = hasPermission(currentRole, "rolesAdd");

  const addRoleHandler = () => {
    if (!name.trim()) {
      toast("Name is mandatory", {
        type: "error",
        hideProgressBar: true,
        autoClose: 2000,
      });
      return;
    }
    dispatch(addRole(name.trim(), permissions));
  };

  const addRoleInfo = useSelector((state) => state.addRoleInfo);
  const { loadingAddRoleInfo, errorAddRoleInfo, addRoleData } = addRoleInfo;

  useEffect(() => {
    if (addRoleData) {
      dispatch({ type: ADD_ROLE_RESET });
      toast("Role added successfully", {
        type: "success",
        hideProgressBar: true,
        autoClose: 2000,
      });
      navigate("/roles");
    } else if (errorAddRoleInfo) {
      dispatch({ type: ADD_ROLE_RESET });
      toast(errorAddRoleInfo, {
        type: "error",
        hideProgressBar: true,
        autoClose: 2000,
      });
    }
  }, [addRoleData, errorAddRoleInfo, dispatch, navigate]);

  if (!canAddRoles) {
    return (
      <div className="w-full h-full">
        <ScreenHeader title="Add role" />
        <p className="mt-6 text-gray-500 italic">You do not have permission to add roles.</p>
      </div>
    );
  }

  return (
    <div className="w-full h-full">
      <ScreenHeader title="Add role" description="Name the role, then tick what people with it can see and do." />
      <div className="bg-white shadow-md rounded px-8 py-8 my-4">
        <h3 className="text-md font-semibold mb-2">Name</h3>
        <Input
          name="Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />

        <RolePermissionChecklist
          permissions={permissions}
          onChange={setPermissions}
          canGrantSuperAdmin={currentRole?.isSuperAdmin === true}
        />

        <Button
          type="button"
          text={loadingAddRoleInfo ? "Adding..." : "Add"}
          custom="mt-6 py-2 px-6"
          onClick={addRoleHandler}
          disabled={loadingAddRoleInfo}
        />
      </div>
    </div>
  );
};

export default AddRole;
